const axios = require('axios')
import { trackEvent } from './analytics'
class AsyncModal {
  modalEle
  modalBody

  constructor(element) {
    this.modalEle = element
    this.modalBody = element.querySelector('.modal_body')

    // Set up modal triggers
    document.querySelectorAll('.js-async-modal').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault()
        this.showModal(trigger)
      })
    })

    // Close modal when modal wrapper is clicked
    this.modalEle.addEventListener('click', e => {
      if (e.target.classList.contains('modal')) {
        this.hideModal()
      }
    })

    // Close modal when dismiss button is clicked
    document.querySelector('.js-hide-modal').addEventListener('click', e => {
      e.preventDefault()
      this.hideModal()
    })

    // Close modal when ESC key is pressed
    document.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.hideModal()
      }
    })
  }

  showModal(trigger) {
    const title = trigger.getAttribute('data-modal-title')

    this.modalEle.querySelector('.modal_title').innerHTML =
      title +
      ' <a href="' +
      trigger.href +
      '" class="icon icon--link" title="Link to this data"></a>'
    this.loadContent(trigger.href)
    this.modalEle.classList.add('modal--visible')

    // Trigger custom event
    const customEvent = trigger.getAttribute('data-modal-event')
    if (customEvent) {
      document.dispatchEvent(new Event(customEvent))
    }
  }

  hideModal() {
    this.modalEle.classList.remove('modal--visible')
    document.dispatchEvent(new Event('modal:on:hide'))
  }

  loadContent(url) {
    this.modalBody.innerHTML =
      '<div class="loader"><div class="dot-bricks"></div></div>'
    this.modalEle.classList.add('modal--loading')

    axios
      .get(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => {
        this.modalBody.innerHTML = response.data

        // Track an event.
        trackEvent('modal', 'view', 'url', url, null)
      })
      .catch(error => {
        Bugsnag.notify(error)

        this.modalBody.innerHTML =
          '<p class="modal_error">😢 Oops! An error occurred and the content couldn’t be loaded.</p>'
      })
      .then(() => {
        this.modalEle.classList.remove('modal--loading')

        document.dispatchEvent(new Event('ajax:complete'))
      })
  }
}

document.addEventListener('turbolinks:load', function () {
  const modal = document.querySelector('.modal')
  if (modal) new AsyncModal(modal)
})
